export type BrokerJobStatus =
	| 'PENDING'
	| 'WAITING_DEPS'
	| 'DISPATCHED'
	| 'RUNNING'
	| 'SUCCEEDED'
	| 'FAILED'
	| 'CANCELLED';

export interface BrokerJob {
	jobId: string;
	serviceUUID: string;
	serviceName: string;
	serviceIcon: string;
	serviceVersion: string;
	status: BrokerJobStatus;
	startedAt: number;
	triggeredBy: string;
	triggeredByDisplayName?: string;
	closedAt: number | null;
	active: boolean;
	error?: string;
	output?: object;
}

export const CANCELLABLE_BROKER_JOB_STATUSES: BrokerJobStatus[] = ['PENDING'];

export interface BrokerService {
	serviceUUID: string;
	serviceName: string;
	active: boolean;
	inputType?: string;
	requiredPermissions?: string[];
	serviceIcon?: string;
	regexFilter?: Record<string, string | undefined>;
}

export interface NxPurgeJobOutput {
	status?: string;
	s3Bucket?: string;
	s3Key?: string;
	recoverable?: boolean;
	alreadyAbsent?: boolean;
}

const NX_PURGE_JOB_OUTPUT_FIELD_TYPES: Record<keyof NxPurgeJobOutput, 'string' | 'boolean'> = {
	status: 'string',
	s3Bucket: 'string',
	s3Key: 'string',
	recoverable: 'boolean',
	alreadyAbsent: 'boolean',
};

// The broker spec leaves `output` untyped: each service writes its own shape, so narrow it at the point of use.
export function isNxPurgeJobOutput(output: unknown): output is NxPurgeJobOutput {
	if (typeof output !== 'object' || output === null || Array.isArray(output)) return false;

	const record = output as Record<string, unknown>;
	return Object.entries(NX_PURGE_JOB_OUTPUT_FIELD_TYPES).every(
		([field, type]) => record[field] === undefined || typeof record[field] === type,
	);
}

export interface BrokerJobDetails {
	jobId: string;
	serviceUUID: string;
	serviceName: string;
	serviceVersion: string;
	status: BrokerJobStatus;
	priority: number;
	deps: string[];
	cacheHits: string[];
	createdAt: number;
	triggeredBy: string;
	triggeredByDisplayName?: string;
	dispatchedAt?: number;
	finishedAt?: number;
	workStarted?: boolean;
	error?: string;
	output?: unknown;
}
